import { render, staticRenderFns } from "./ExamineeSubject.vue?vue&type=template&id=fbbcbca0&scoped=true&"
import script from "./ExamineeSubject.vue?vue&type=script&lang=js&"
export * from "./ExamineeSubject.vue?vue&type=script&lang=js&"
import style0 from "./ExamineeSubject.vue?vue&type=style&index=0&id=fbbcbca0&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbbcbca0",
  null
  
)

export default component.exports